
import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import VideoTab from '../videoTab/videoTab.vue';
import FontContent from '../fontContent/fontContent';
import WordPronunciation from '../wordPronunciation/wordPronunciation';
import NumPronunciation from '../numPronunciation/numPronunciation';
import StyleContent from '../styleContent/styleContent';
import TextTemplateContent from '../TextTemplateContent/TextTemplateContent';
import BrainPowerTitle from '../brainPowerTitle/brainPowerTitle';
import { TabTypeMap } from '../../utils/constant';
import FontFaceObserver from 'fontfaceobserver';
import { Inject } from 'vue-property-decorator';
import { Prop, Watch } from 'vue-property-decorator'
import { judgeDeviceType } from '@/utils/device';
import { compareObjects, debouncedSaveArticle, fontNameEn } from '../../utils/utils';
import { toast } from '@/utils/util';
import { checkTextContent, isPunctuationOnly } from '@/utils/utils';

const _tabList_ = [
  {
    id: 0,
    title: '字体',
    component: 'FontContent',
  },
  {
    id: 1,
    title: '样式',
    component: 'StyleContent'
  },
  {
    id: 2,
    title: '文字发音',
    component: 'WordPronunciation'
  },
  {
    id: 3,
    title: '数字发音',
    component: 'NumPronunciation'
  },
  {
    id: 4,
    title: '文字模板',
    component: 'TextTemplateContent'
  },
  {
    id: 5,
    title: '智能标题',
    component: 'BrainPowerTitle'
  },
]

/**components**/
@Component({
  components: {
    VideoTab,
    FontContent,
    StyleContent,
    WordPronunciation,
    NumPronunciation,
    TextTemplateContent,
    BrainPowerTitle
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class StylePopup extends Vue{
  @Prop({default: false})
  visible: boolean
  @Inject({from: 'triggerEditorSubtitle'})
  triggerEditorSubtitle
  @Prop({default: ''})
  scaleRatio: string
  rcTTSWordList = []
  state = new PageState();
  subtitlesText = ''; // 字幕内容
  oldSubtitlesText = ''; // 原始字幕内容
  show = false
  tabList = JSON.parse(JSON.stringify(_tabList_));
  fontList = [];
  activeTab = this.tabList[0];
  activeFont = this.fontList[1] || {}
  subTitleParams: any = {}
  subTitleSourceParams: any = {source: ''}
  
  source = ''
  defaultHeight = 0
  newHeight = 0
  visualViewportHeight = 0
  scrollerHeight
  videoEditor: HTMLElement
  coverWrapper: HTMLElement
  styleContentHeight = '100%'
  oldSubtitleInfo = {}
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  
  mounted() {
    this.getFontFamilyList()
    this.defaultHeight = window.innerHeight
    this.videoEditor = document.getElementsByClassName('videoEditor')[0] as HTMLElement;
    if (judgeDeviceType.isAndroid) {
      const innerHeight = window.innerHeight;
      window.addEventListener('resize', () => {
        const newInnerHeight = window.innerHeight;
        if (innerHeight > newInnerHeight) {
          // 键盘弹出事件处理 
          this.onFocus()    
        } else {
          // 键盘收起事件处理
          this.onBlur()
        }
      });
    }
    this.$bus.$on(this.$EventBusKey.CHANGE_STYLE_FONTFAMILY, this.changeFontFamily)
  }
  beforeDestroy() {
    this.$bus.$off(this.$EventBusKey.CHANGE_STYLE_FONTFAMILY, this.changeFontFamily)
  }
  get stylePopupContent() {
    if ((this.source === 'cover' || this.source === 'brain_title') && this.state.styleContentHeight && !this.isFocus) {

      return this.state.styleContentHeight
    }
    return this.styleContentHeight
  }
  @Watch('newHeight')
  listenNewHeight() {
    this.visualViewportHeight = Math.abs(this.newHeight - this.defaultHeight)
  }
  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (!val) {
      const compareList = compareObjects(this.oldSubtitleInfo, this.state.subtitleInfo)
      if (compareList.length > 0) {
        this.$bus.$emit(this.$EventBusKey.SAVE_DATA)
      }
     
    } else {
      if (this.source !== 'cover' && this.source !== 'shortPlay') {
        if (this.state.subtitleInfo.fontPercent) {
          this.$nextTick(() => {
            this.setFontPercent(this.state.subtitleInfo.fontPercent)
          })
        }
      }

      this.oldSubtitlesText = this.subtitlesText
      this.oldSubtitleInfo = JSON.parse(JSON.stringify(this.state.subtitleInfo))
    }
  }

  @Watch('state.operatingTextContent.id')
  listenOperatingTextTemplateId(val) {
    this.subtitlesText = this.state.operatingTextContent.text
  }

  @Watch('state.subtitleInfo.fontPercent')
  onFontResize() {
    if (this.state.subtitleInfo.fontPercent) {
      this.$nextTick(() => {
        this.setFontPercent(this.state.subtitleInfo.fontPercent)
      })
    }
  }

  setFontPercent(value){
    if (this.$refs.styleContentRef) {
      (this.$refs.styleContentRef as any).fontPercent = value
    }
  }
  changeFontFamily() {
    const { fontFamily } = this.state.subtitleInfo
    this.activeFont = this.fontList.find(item => item.nameEn === fontFamily) || this.fontList[0]
  }
  // 字体初始化
  initFontFamily() {
    const { fontFamily } = this.state.subtitleInfo
    if (this.fontList.length === 0) {
      return
    }
    this.activeFont = this.fontList.find(item => item.nameEn === fontFamily) || this.fontList[0]
    this.state.subtitleInfo.fontFamily = this.activeFont.nameEn
    
    this.$bus.$emit('download-fontFamily')
  }

  activeTabType = null

  get handleTabList() {
    const list = this.tabList.filter(item => {
      return (
        this.source === 'text_template' && (this.activeTabType === TabTypeMap.ADD_TEXT_CONTENT || TabTypeMap.EDIT_TEXT_CONTENT || this.activeTabType === TabTypeMap.EDIT_TEXT_CONTENT_STYLE || this.activeTabType === TabTypeMap.EDIT_TEXT_TEMPLATE)
          // ? item.id === 0 || item.id === 1 || item.id === 4
          ? (item.id === 4 || item.id === 0 || item.id === 1)
          : item.component !== 'TextTemplateContent'
      )
    })
    if (this.source === 'text_template') {
      const element = list.pop()
      if (element) {
        list.unshift(element)
      }
    }
    return list
  }

  /**
   * 设置参数
   * @param params
   */
  setParams(type, params) {
    this.activeTabType = type
    if (type === TabTypeMap.STYLE || type === TabTypeMap.EDITFONT) {
      this.activeTab = this.tabList.find(item => item.id === 1)
    } else if (type === TabTypeMap.ADD_TEXT_CONTENT || type === TabTypeMap.EDIT_TEXT_CONTENT) {
      this.activeTab = this.tabList.find(item => item.id === 4)
    } else if (type === TabTypeMap.EDIT_TEXT_CONTENT_STYLE) {
      this.activeTab = this.tabList.find(item => item.id === 4)
    } else if (type === TabTypeMap.EDIT_TEXT_TEMPLATE) {
      this.activeTab = this.tabList.find(item => item.id === 4)
    } else if (type === TabTypeMap.WORDPRON) {
      this.activeTab = this.tabList.find(item => item.id === 2)
    } else if (type === TabTypeMap.NUMPRON) {
      this.activeTab = this.tabList.find(item => item.id === 3)
    } else if (type === TabTypeMap.BRAIN_TITLE) {
      this.activeTab = this.tabList.find(item => item.id === 5)
    } else {
      this.activeTab = this.tabList.find(item => item.id === 0)
    }
    if (params) {
      this.subtitlesText = params.text || ''
      this.oldSubtitlesText = params.text || ''
      console.log("setParams", params)
      if (params.source && (params.source === 'cover' || params.source === 'shortPlay')) {
        const index = this.tabList.findIndex(item => item.id === 2 || item.id === 3)
        if (index !== -1) {
          this.tabList.splice(2, this.tabList.length - 2)
        }
        this.subTitleSourceParams = params
        this.source = params.source
        this.$nextTick(() => {
          if (params?.fontPercent) this.setFontPercent(params.fontPercent);
          // 字体颜色选中
          if (this.$refs.styleContentRef) {
            (this.$refs.styleContentRef as any).activeColor = params.fontColour;
          }
          if(params.source === 'shortPlay') this.subTitleParams = params;
          // 字体选中
          if(params.fontFamily && this.fontList.length) {
            this.activeFont = this.fontList.find(item => item.nameEn === params.fontFamily) || this.fontList[0]
          }
        })
      } else if (params.source === 'text_template') {
        // 文字模板
        this.source = params.source
        this.tabList = JSON.parse(JSON.stringify(_tabList_))
      } else if (params.source === 'brain_title') {
        const idList = [0, 1, 5]
        let _tabList = []
        idList.forEach(item => {
          const info = _tabList_.find(_item => _item.id === item)
          if (info) {
            _tabList.push(JSON.parse(JSON.stringify(info)))
          }
        })
        this.tabList = _tabList
        this.source = params.source
      }else if (this.state.workType === 'down_stress') {
        const _tabList = _tabList_.filter(item => item.id !== 2 && item.id !== 3)
        this.tabList = _tabList
        this.tabList.pop()
      } else {
        this.tabList = JSON.parse(JSON.stringify(_tabList_))
        this.tabList.pop()
        this.subTitleParams = {...this.state.subtitleInfo, ...params}
        this.source = ''
      }
      this.rcTTSWordList = params.rcttsWordList
      
    }
  }
  closePopup() {
    this.$emit('close')
  }

  /**
   * 输入内容变化
   */
  async inputContent(text) {
    // 检测文案风险
    const checkRes = await checkTextContent(this, text);
    if (checkRes) return;

    if (this.source === 'brain_title') return
    if (this.source === 'cover') {
      console.log('inputContent', this.subTitleSourceParams)
      const _subTitleParams = {...this.subTitleSourceParams, text: text}
      const type = this.activeTab.id === 0 ? TabTypeMap.FONT : TabTypeMap.EDITFONT
      this.triggerEditorSubtitle(_subTitleParams, type)
      this.$bus.$emit('input-subtitle', _subTitleParams, this.subTitleSourceParams.index)
    } else if (this.source === 'text_template') {
      this.state.operatingTextContent.text = text
      this.state.operatingTextList = this.state.operatingTextList.map((item, index) => {
        return (
          this.state.operatingTextIndex === index
            ? this.state.operatingTextContent
            : item
        )
      })
    } else {
      if (isPunctuationOnly(this.subtitlesText.trim()) && this.source !== 'cover' && this.source !== 'text_template') {
        toast('请输入有效的文本')
        return
      }
      if (this.subtitlesText.length > 18) {
        this.subtitlesText = this.subtitlesText.substring(0, 18)
        text = text.substring(0, 18)
        toast('最多输入18个字', 'top')
      }
      if (!text.trim()) {
        toast('内容不能为空', 'top')
        // return
      }
      debouncedSaveArticle(this)
      this.$emit('input', text)
    }
  }
  onTouchstart() {
    (this.$refs.inputRef as any).blur()
  }
  isFocus = false
  onFocus() {
    this.isFocus = true
    const ratioList = this.scaleRatio.split(':')
    let scrollTop = 150
    if (Number(ratioList[0]) > Number(ratioList[1])) {
      scrollTop = 100
    }
    if (judgeDeviceType.isAndroid) {
      this.styleContentHeight = 4 + 'rem'
      if (this.source === 'cover') {
        this.coverWrapper = document.getElementsByClassName('cover-picker-wrapper')[0] as HTMLElement;
        if (!this.coverWrapper) return
        this.coverWrapper.style.paddingBottom = '300px'
        let timer = setTimeout(() => {
          this.coverWrapper.scrollTo(0, scrollTop)
          clearTimeout(timer)
          timer = null
        }, 150)
      } else {
        let timer = setTimeout(() => {
          this.videoEditor.scrollTo(0, scrollTop)
          clearTimeout(timer)
          timer = null
        }, 150)
      }
      (this.$refs.fontStyleContentRef as HTMLElement).style.overflowY = 'hidden'
    }
    
  }
  get maxLength() {
    if (this.source === 'text_template' &&  this.state.operatingTextContent.id) {
      return this.operatingTextTemplateItem.maxLength
    } 
    return 'auto'
  }
  onBlur() {
    this.isFocus = false
    if ( this.coverWrapper) {
      this.coverWrapper.style.paddingBottom = '0px'
      this.coverWrapper.scrollTo(0, 0)
    }
   
    this.videoEditor.scrollTo(0, 0)
    this.styleContentHeight = '100%';
    (this.$refs.fontStyleContentRef as HTMLElement).style.overflowY = 'auto';
    if (isPunctuationOnly(this.subtitlesText.trim()) && this.source !== 'cover' && this.source !== 'text_template') {
      toast('请输入有效的文本')
      return
    }
    if (this.subtitlesText.length > 18 && this.source !== 'cover' && this.source !== 'text_template') {
      this.subtitlesText = this.subtitlesText.substring(0, 18)
      toast('最多输入18个字', 'top')
    }
  }
  /**
   * 提交字幕
   */
  confirmSubtitle() {
    if (isPunctuationOnly(this.subtitlesText?.trim()) && this.source !== 'cover' && this.source !== 'text_template') {
      toast('请输入有效的文本')
      return
    }
    if (!this.subtitlesText?.trim() && 
    this.source !== 'cover' && 
    this.source !== 'text_template' && 
    this.source !== 'brain_title') {
      toast('内容不能为空', 'top')
      return
    }
    console.log('confirmSubtitle', this.activeTab)
    this.$emit('confirm', this.source)
  }
  /**
   * 切换tab
   * @param tabIndex 
   */
  changeTab(tab) {
    if (this.source === 'text_template' && (tab.id === 0 || tab.id === 1) && !this.subtitlesText) {
      this.$toast('请先输入文本内容')
      return
    }
    this.activeTab = tab
  }
  /**
   * 选择当前字体
   * @param font
   */
  async selectFont(fontItem) {
    if(fontItem.downStatus !== 0){
      // 下载字体
      this.downloadFont(fontItem)
      return
    }
    this.activeFont = fontItem
    if (this.source === 'cover') {
      const _subTitleParams = {...this.subTitleSourceParams, fontFamily: fontItem.nameEn}
      this.triggerEditorSubtitle(_subTitleParams, TabTypeMap.FONT)
      this.$bus.$emit('input-subtitle', _subTitleParams)
      
    } else if (this.source === 'text_template') {
      if (this.state.operatingTextIndex !== null) {
        this.state.operatingTextList[this.state.operatingTextIndex].fontFamily = fontNameEn(fontItem.nameEn)
      }
    } else {
      this.state.subtitleInfo.fontFamily = fontItem.nameEn
      debouncedSaveArticle(this)
    }
  }
  /**
   * 下载字体
   * @param font
   */
  downloadFont(font) {
    const fontIndex = this.fontList.findIndex(item => item.id === font.id)
    const fontItem = this.fontList[fontIndex]
    fontItem.downStatus = 2
    this.downloadFontFamily(fontItem).then(() => {
      fontItem.downStatus = 0
      localStorage.setItem('fontFamilyList', JSON.stringify(this.fontList))
      this.$bus.$emit('download-fontFamily')
    }).catch(e => {
      fontItem.downStatus = 1
      console.log('下载字体失败，请稍后重试', e, e?.message)
      this.$toast('下载字体失败，请稍后重试')
    }).finally(() => {
      this.$http('downloadRecord', {
        fontId: fontItem.id
      })
    })
  }
  getFontFamilyList() {
    this.$http('getFontList').then((res) => {
      if (res.code === 200) {
        this.fontList = res.data.map((item, index) => {
          item['downStatus'] = index === 0 ? 0 : 1
          return item
        })
        const fontFamilyStr = localStorage.getItem('fontFamilyList')
        if (fontFamilyStr) {
          const _fontList = JSON.parse(fontFamilyStr)
          this.fontList.forEach((item) => {
            const _fontItem = _fontList.find(fontItem => fontItem.id === item.id)
            if (_fontItem) {
              item.downStatus = _fontItem.downStatus
            }
          })
        }

        const downList = this.fontList.filter((item) => item.nameEn === "" || item.id === 6 || item.downStatus !== 1)
        console.log('fontList', downList)
        this.downloadAllFontFamily(downList).then((res)=>{
          res.forEach(({status, fontItem})=>{
            fontItem.downStatus = status === 'success' ? 0: 1
          })
          this.initFontFamily()
        })
      }
    })
  }
  downloadAllFontFamily(list) {
    return Promise.all(list.map(fontItem => {
      return this.downloadFontFamily(fontItem).then(() => {
        return { status: 'success', fontItem }
      }).catch(error => {
        return { status: 'failed', fontItem, error }
      })
    }))
  }
  downloadFontFamily(fontItem) {
    // 创建一个新的样式元素
    const styleElement: HTMLStyleElement = document.createElement('style');
    let nameEn = fontItem.nameEn
    nameEn = fontNameEn(nameEn)
    // 定义要添加到样式表中的CSS规则
    const cssRule = `@font-face { font-family: ${nameEn}; src: url(${fontItem.url}); }`;

    // 将CSS规则添加到样式元素中
    styleElement.appendChild(document.createTextNode(cssRule));

    // 将样式元素添加到文档头部或其他需要应用该字体的位置
    document.head.appendChild(styleElement);

    const font = new FontFaceObserver(nameEn)
    return font.load(null, 20000)
  }

	/****************************** 文字模板 ******************************/

	// 当前的文字模板
	get operatingTextTemplateItem():any {
		let textTemplate = {}
		this.state.defaultTextTemplateList.forEach(item => {
			if (item.id === this.state.operatingTextContent.id) {
				textTemplate = item
			}
		})
		return textTemplate
	}
}